<ds-modal [modal]="modal" [title]="'remove_user' | translate" [maxWidthPercentage]="50" (modalClosed)="onCancel()">
  <div class="modal-content-wrapper">
    <div data-test-id="description">
      @if (willBeRemoved) {
        <p>{{ 'remove_user_from_platform_description' | translate: groupName }}</p>
      } @else {
        <p>{{ 'remove_user_description' | translate: groupName }}</p>
      }
    </div>
    <div class="d-flex gap-3 mt-4">
      <button ds-button type="button" [variant]="DsButtonVariants.primary" (click)="onConfirm()" data-test-id="confirm-button">
        {{ 'remove_user' | translate }}
      </button>
      <button ds-button type="button" [variant]="DsButtonVariants.secondary" (click)="onCancel()" data-test-id="cancel-button">
        {{ 'form_cancel' | translate }}
      </button>
    </div>
  </div>
</ds-modal>
